/* eslint semi:0 */
import 'isomorphic-fetch'
import { warn, } from 'application/console'
import { registerUtils, } from 'application/nm'
import { create as makeEmptyObj, } from 'utils/object'


function json(response){
  return response.json()
}

function handleResponseCode(response){
  return response.ok ? response : Promise.reject(response)
}

function handleFetchError(url, response){
  const { status, statusText, } = response // eslint-disable-line no-shadow
  const errorMessage = `Failed fetching url '${ url }'!
  Status ${ status }, statusText '${ statusText }'.`
  warn(errorMessage, { url, status, statusText, response, })
  return new Error(errorMessage)
}

function getResponseText(url, conf = {}){
  return fetch(url, conf)
    .then(handleResponseCode)
    .catch(handleFetchError.bind(null, url))
}

export const fetchUtils = Object.assign(makeEmptyObj(), {
  getResponseText,
  getJsonOrError(url, conf = {}){
    return getResponseText(url, conf)
      .then(json)
  },
})

registerUtils({ fetchUtils, })


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/fetch.js